export default "__VITE_ASSET__eb9a6361__"